import { AxiosResponse, default as axios } from 'axios';
import { Widget } from '../Model';
import { Auth } from '@trustpilot/ecommscript-integrationappauth';
import { logError } from './ecommscriptClient';

const settingApiUrl = `${process.env.REACT_APP_SettingsApiUrl}/api/settings`;

export const getTrustBoxList = (integrationKey: string, locale: string): Promise<Widget[]> => {
    const queryParams = locale ? `?locale=${locale}` : '';
    return axios
        .get(`${settingApiUrl}/${integrationKey}/widgets${queryParams}`, { headers : {
            Accept: 'application/json',
            authorization: `Bearer ${Auth.getAccessToken()}`,
        }})
        .then((response: AxiosResponse<Widget[]>) => {
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error(`Failed to retrieve widgets. Reason: ${response.data}`);
            }
        }).catch(((reason) => {
            logError(reason);
            return [];
        }));
};



// WEBPACK FOOTER //
// ./src/Api/trustboxClient.ts